export default __webpack_public_path__ + "static/media/6.613b1690.png";